import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=0fd040ba&scoped=true"
import script from "./Passenger.vue?vue&type=script&lang=js"
export * from "./Passenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd040ba",
  null
  
)

export default component.exports